"use strict";
angular.module('planCommandMonitorRegionalHotspotsRelateArticleModule', [])
    .controller('planCommandMonitorRegionalHotspotsRelateArticleCtrl', ["$scope", "$filter", "trsHttpService", '$stateParams','item','$modalInstance',
        function($scope, $filter, trsHttpService, $stateParams,item,$modalInstance) {
            initData();
            initStatus();
            /**[initData description:初始化数据]*/
            function initData() {
                $scope.status = {
                    page: {
                        CURRPAGE: 1,
                        PAGESIZE: 20,
                        ITEMCOUNT: 0,
                        PAGECOUNT: '',
                        CurrPageCopy: 1
                    }
                };
                $scope.artParams = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'areaHotPointFunCommon',
                    "method": 'getRelatedArticles',
                    // "cluster_guids": $stateParams.cluster_guids,
                    "search_hour": item.transmitSearch,  //
                    "page_no": $scope.status.page.CURRPAGE - 1,
                    "page_size": $scope.status.page.PAGESIZE,
                    "areahot_id": item.info.areahot_id,//
                    "hot_type":item.hot_type //
                };
                requestData();
            }
            /**[initStatus description:初始化状态]*/
            function initStatus() {
                $scope.curroute = ["策划资源", "指挥监测中心", "地域热点管理"];
            }
            $scope.cancel=function(){
                $modalInstance.dismiss();
            };
            /**[RelateArticle description:相关文章的接口请求]*/
            function requestData() {
                // console.log(artParams);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.artParams, 'post').then(function(data) {
                    $scope.relatedData = data.mapResult.content.pageItems;
                    $scope.indexNm = data.mapResult.indexNm;
                    $scope.curroute[3] =item.info.sighTitle;
                    $scope.relaTitle = item.info.sighTitle;
                    $scope.status.page.ITEMCOUNT = data.mapResult.content.totalItemCount;
                    $scope.status.page.PAGECOUNT = data.mapResult.content.pageTotal;
                    // console.log(data);
                });
            }
            /*[selectPageNum description] 选择每页显示的数据数量*/
            $scope.selectPageNum = function() {
                $scope.status.page.CurrPageCopy = 1;
                $scope.artParams.page_no = $scope.status.page.CURRPAGE - 1;
                $scope.artParams.page_size = $scope.status.page.PAGESIZE;
                requestData();
            };
            /**[pageChanged description] 分页*/
            $scope.pageChanged = function() {
                $scope.artParams.page_no = $scope.status.page.CURRPAGE - 1;
                $scope.status.page.CurrPageCopy = $scope.status.page.CURRPAGE;
                requestData();
            };
            /**[jumpToPage description] 跳转到指定页面]*/
            $scope.jumpToPage = function() {
                if ($scope.status.page.CurrPageCopy > $scope.status.page.PAGECOUNT) {
                    $scope.status.page.CurrPageCopy = $scope.status.page.PAGECOUNT;
                }
                $scope.artParams.page_no = $scope.status.page.CurrPageCopy - 1;
                $scope.status.page.CURRPAGE = $scope.status.page.CurrPageCopy;
                requestData();
            };
        }
    ]);